<template>
  <div>
    <vx-card>
      <div class="flex h-12 mt-1 fit-height">
        <div class="w-full ml-2 fit-height">
          <form v-on:submit.prevent="salvar" id="formulario">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Central de Vendas</label>
                  <div class="vs-con-input">
                    <the-mask
                      :mask="['(##) ####-####', '(##) #####-####']"
                      v-model="contato.central_vendas"
                      type="text"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-phone null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Já sou cliente</label>
                  <div class="vs-con-input">
                    <the-mask
                      :mask="['(##) ####-####', '(##) #####-####']"
                      v-model="contato.ja_cliente"
                      type="text"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-phone null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">WhatsApp</label>
                  <div class="vs-con-input">
                    <the-mask
                      :mask="['(##) ####-####', '(##) #####-####']"
                      v-model="contato.whatsapp"
                      type="text"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-phone null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Atendente Online</label>
                  <div class="vs-con-input">
                    <input
                      v-model="contato.atendente_online"
                      type="url"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-external-link null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>
          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

import {TheMask} from 'vue-the-mask'

export default {
  components: {
    TheMask
  },
  data() {
    return {
      contato: {
        central_vendas: '',
        ja_cliente: '',
        whatsapp: '',
        atendente_online: ''
      },
    }
  },
  methods: {
    salvar: function() {
      fetch(this.$API_URL + "/formas-contato/", {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.contato)
      })
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }
      })
    },
    getFormas: function() {
      fetch(this.$API_URL + "/formas-contato/dados", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        this.contato = json.data[0]
      });
    }
  },
  mounted() {
    this.getFormas();
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
